import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"; 
import { useCart } from "../context/CartContext"; 
import ServiceCard from "../components/ServiceCard";

function Services() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { addToCart, getCartCount } = useCart(); 

  const services = t("servicesList", { returnObjects: true });
  
  const exclusiveMedicines = [
    { 
      id: "em1", 
      name: t("exclusive.medicines.sepil") || "Sepil: Advanced Wound Care", 
      price: 422, 
      imgSrc: "/images/sepil.png" 
    },
    { 
      id: "em2", 
      name: t("exclusive.medicines.nanoHeal") || "Nano Heal: Veterinary", 
      price: 195, 
      imgSrc: "/images/nano-heal.png" 
    }
  ];

  const [quantities, setQuantities] = useState({
    em1: 0,
    em2: 0
  });

  const handleQtyChange = (id, val) => {
    const value = Math.max(0, parseInt(val) || 0);
    setQuantities((prev) => ({ ...prev, [id]: value }));
  };

  const handleAddSelection = (med) => {
    const qty = quantities[med.id] || 0;
    if (qty > 0) {
      addToCart(med, qty);
      setQuantities(prev => ({ ...prev, [med.id]: 0 }));
    } else {
      alert(t("exclusive.alertError") || "Please select a quantity greater than 0");
    }
  };

  return (
    <div className="page services-page" style={{ background: "#f1f8f5" }}>
      
      {/* 1. EXCLUSIVE SECTION */}
      <section className="section-block exclusive-section" style={{ background: "#eef4f1", paddingTop: "80px", paddingBottom: "60px" }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="section-label">{t("exclusive.label") || "Premium Care"}</div>
          <h2 style={{ marginBottom: "10px" }}>{t("exclusive.title") || "Exclusive Patented Medicine"}</h2>
          
          <p style={{ 
            marginBottom: "40px", 
            color: "#ffffff", 
            backgroundColor: "#d9534f", 
            display: "inline-block",
            padding: "6px 16px",
            borderRadius: "50px",
            fontWeight: "700",
            fontSize: "0.9rem",
            boxShadow: "0 4px 10px rgba(217, 83, 79, 0.3)"
          }}>
            {t("exclusive.offer") || "Save 10% instantly when you order 2 or more units!"}
          </p>
          
          <div className="medicine-purchase-grid" style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
            gap: '25px',
            textAlign: 'left' 
          }}>
            {exclusiveMedicines.map((med) => (
              <div key={med.id} className="contact-form-box" style={{ 
                padding: '25px', 
                border: '1px solid #e1e8ed',
                background: '#fff',
                borderRadius: '15px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '20px' }}>
                  <img 
                    src={med.imgSrc} 
                    alt={med.name} 
                    style={{ width: '100px', height: '100px', objectFit: 'contain' }} 
                  />
                  <div>
                    <h3 
                      onClick={() => {
                        if (med.id === "em1") navigate("/products/sepil-spray");
                        if (med.id === "em2") navigate("/products/nano-heal-spray");
                      }}
                      style={{ 
                        color: 'var(--secondary-color)', 
                        marginBottom: '5px', 
                        fontSize: '1.1rem',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        transition: 'color 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = "var(--primary-color)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = "var(--secondary-color)";
                      }}
                      title="Click to view full specifications"
                    >
                      {med.name}
                    </h3>
                    <div style={{ fontSize: '1.4rem', fontWeight: '700', color: 'var(--primary-color)' }}>
                      ₹{med.price}
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '12px',
                  background: '#f8f9fa',
                  padding: '12px',
                  borderRadius: '12px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <label style={{ fontWeight: '600', fontSize: '0.85rem', color: '#333' }}>
                        {t("exclusive.qtyLabel") || "Qty:"}
                    </label>
                    <input 
                      type="number" 
                      min="0" 
                      value={quantities[med.id]} 
                      onChange={(e) => handleQtyChange(med.id, e.target.value)}
                      style={{ width: '55px', padding: '8px', textAlign: 'center', borderRadius: '6px', border: '1px solid #ddd', fontWeight: 'bold' }}
                    />
                  </div>
                  <button 
                    className="btn-primary" 
                    onClick={() => handleAddSelection(med)}
                    style={{ flex: 1, padding: '10px', fontSize: '0.8rem', whiteSpace: 'nowrap' }}
                  >
                    {t("exclusive.addBtn") || "Add to Selection"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 2. OPTIMIZED MIDDLE BANNER (Significantly reduced vertical space) */}
      <section className="page-hero" style={{ padding: "35px 0", background: "#d1e7dd", borderTop: "1px solid #c3dec2", borderBottom: "1px solid #c3dec2" }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="section-label" style={{ 
            margin: "0 auto 10px", 
            backgroundColor: "#b3d7c6", 
            color: "#0d5a44",
            fontSize: "0.75rem",
            padding: "4px 12px"
          }}>
            {t("services.label")}
          </div>
          <h2 style={{ 
            fontSize: "1.8rem", 
            marginBottom: "8px", 
            color: "#1b4332",
            fontWeight: "800" 
          }}>
            {t("services.title")}
          </h2>
          <p style={{ 
            maxWidth: "650px", 
            margin: "0 auto", 
            color: "#2d6a4f", 
            fontSize: "0.95rem",
            lineHeight: "1.4"
          }}>
            {t("services.subtitle")}
          </p>
        </div>
      </section>

      {/* 3. ALL CATEGORIES SECTION */}
      <section className="section-block" style={{ background: "transparent", paddingTop: "50px" }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="section-label">{t("services.allCategoriesLabel") || "All Categories"}</div>
          <h2 style={{ marginBottom: "30px" }}>{t("services.browseSpecialty") || "Browse by Specialty"}</h2>
          <div className="services-grid" style={{ textAlign: 'left' }}> 
            {Array.isArray(services) && services.map((service) => (
              <div id={`product-${service.id}`} key={service.id} className="service-anchor-wrapper">
                <ServiceCard {...service} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FLOATING CHECKOUT BAR */}
      {getCartCount() > 0 && (
        <div style={{
          position: 'fixed',
          bottom: '30px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#0d7a5f', 
          color: 'white',
          padding: '12px 25px',
          borderRadius: '50px',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          zIndex: 2000,
          minWidth: '320px',
          justifyContent: 'space-between',
          border: '2px solid rgba(255,255,255,0.2)'
        }}>
          <div style={{ fontWeight: '700', fontSize: '1rem', color: '#ffffff' }}>
            🛒 {getCartCount()} {getCartCount() === 1 ? t("cart.item") : t("cart.items")}
          </div>
          <button 
            onClick={() => navigate("/checkout")}
            style={{ 
              backgroundColor: '#ffffff', 
              color: '#0d7a5f', 
              border: 'none',
              padding: '10px 20px',
              borderRadius: '25px',
              fontWeight: 'bold',
              cursor: 'pointer',
              fontSize: '0.9rem',
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
            }}
          >
            {t("cart.checkoutBtn") || "Review & Checkout →"}
          </button>
        </div>
      )}
    </div>
  );
}

export default Services;